import styled, { keyframes } from 'styled-components'

const bgAnimation = keyframes`
    0% {
        background-position: right;
    }
    100% {
        background-position: left;
    }
`

export const AnimatedButton = styled.button`
    background: linear-gradient(to right, #cfe2ff 50%, white 50%);
    background-size: 200% 100%;
    background-position: right;
    animation: ${bgAnimation} 30s linear forwards;
    border-width: 1px;
    border-style: solid;
    border-color: #005eb8;
    border-radius: 0.375rem;
    color: #005eb8;
    &:disabled {
      border-color: #D9D9D9;
      background: #dedede;
      color:#929292;
       }
`
